import type { OrderStatus } from '../../../constants/order';
import type { AssociateOrderData, CustomerOrder, Order, UserOrderCard } from '../../../model/order/order';

export type GetOrderRequest = {
  orderId: number | string;
  email?: string;
  sessionKey?: string;
};

export type GetOrderResponse = Order;

export type GetCustomerOrderRequest = {
  orderId: number;
  email?: string;
};

export type GetCustomerOrderResponse = CustomerOrder;

export type GetOrdersRequest = {
  page?: number;
  perPage?: number;
  status?: OrderStatus;
  sessionKey?: string;
  customerId?: number;
};

export type GetOrdersResponse = {
  orders: Order[];
  total: number;
  totalPages: number;
};

export type GetUserOrdersRequest = {
  userId: number;
  cursor?: string;
  limit?: number;
};

export type GetUserOrdersResponse = {
  items: UserOrderCard[];
  nextCursor: string | null;
};

export type AssociateOrderRequest = {
  orderId: number;
};

export type AssociateOrderResponse = {
  success: boolean;
  message: string;
  data: AssociateOrderData;
};

/**
 * Edit shipping address request - for updating shipping info after order creation
 * Used for Express Checkout when required fields are missing
 */
export type EditShippingAddressRequest = {
  orderId: number;
  firstName: string;
  lastName: string;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  postcode: string;
  country: string;
  phone: string;
  taxId?: string;
};

export type EditShippingAddressResponse = {
  success: boolean;
  message?: string;
};

/**
 * Edit billing address request - for updating billing info after order creation
 * Used for Express Checkout to update billing address with payer data
 * Note: Orders can only be edited within 5 minutes of creation
 */
export type EditBillingAddressRequest = {
  orderId: number;
  firstName?: string;
  lastName?: string;
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  postcode?: string;
  country?: string;
  phone?: string;
  email?: string;
};

export type EditBillingAddressResponse = {
  message: string;
};

export type GetOrderByTrackingRequest = {
  trackingNo: string;
};

export type GetOrderByTrackingResponse = Order[];
